import { render, staticRenderFns } from "./widget-slider.vue?vue&type=template&id=1b72dbb8&scoped=true"
import script from "./widget-slider.vue?vue&type=script&lang=js"
export * from "./widget-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72dbb8",
  null
  
)

export default component.exports